import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { IconButton } from '@material-ui/core'
import CancelScheduleSendOutlinedIcon from '@material-ui/icons/CancelScheduleSendOutlined'

import { CANCEL } from 'app/constants/button'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const Unsend = (props) => {
  const { onUnsend, onDialog, isReminder = false } = props
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
    onDialog(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    onDialog(false)
  }

  return (
    <>
      <PrimaryTooltip
        title={formatMessage({
          id: 'notificationTimeline.card.action.unsend',
        })}
      >
        <IconButton
          aria-label="Unsend Button Icon"
          size="small"
          className="text-red-500"
          id="column-date-action"
          onClick={() => {
            handleOpen()
          }}
        >
          <CancelScheduleSendOutlinedIcon fontSize="small" />
        </IconButton>
      </PrimaryTooltip>
      <SubmitDialog
        id="dialog-unsend-timeline"
        open={isOpen}
        type={CANCEL}
        title={
          isReminder
            ? formatMessage({
                id: 'timeline.dialog.title.unsent.reminder',
              })
            : formatMessage({
                id: 'timeline.dialog.title.unsent',
              })
        }
        description={
          isReminder
            ? formatMessage({
                id: 'timeline.dialog.description.unsent.reminder',
              })
            : formatMessage({
                id: 'timeline.dialog.description.unsent',
              })
        }
        submitText={formatMessage({
          id: 'notificationTimeline.card.action.unsend',
        })}
        onSubmit={async () => {
          await onUnsend()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

Unsend.propTypes = {
  onUnsend: PropTypes.func,
  onDialog: PropTypes.func,
  isReminder: PropTypes.bool,
  className: PropTypes.string,
}

export default Unsend
